import { Component } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({ standalone: false,
  selector: 'vfa-cp-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  public options: AnimationOptions = {
    path: './assets/lotties/76051-red-car.json',
  };
  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
}

